import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentBoardEvent, SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { openBoardSettings } from '../../../../../../base/effects/openBoardSettings';
import { SegmentBoardSettingsSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/boardEvents';
import { EBoardSetting } from '../../../../../boardDetails/details/TabDetails/components/TabDetails/types';

export const onEditRoles = (): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(openBoardSettings(EBoardSetting.ROLES, SegmentBoardSettingsSourceValue.CARD_ASSIGNEES_EDIT_ROLES));
        dispatch(segmentTrackAction(SegmentCardEvent.EDIT_ROLES_LINK));
    }
    return action;
}
